<template>
    <div class="d-flex flex-column h-full p-3 common-background-color-revamp"
        :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
        <div class="d-flex flex-column">
            <b-row>
                <b-col>
                    <b-card class="card-border-radius common-shadow noborder" body-class="body-landing">
                        <div class="">
                            <b-row class="mt-1 pt-1 pr-2">
                                <b-col class="text-left text-align-self-end">
                                    <span style="vertical-align: baseline"
                                        class="font-anuphan-bold-16 text-revamp-color-black">ข้อแนะนำการอัปโหลดเอกสารทุกรายการ</span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-1 pt-1 pr-2" v-if="recommentDocList.length > 0">
                                <ul style="display: flex; flex-direction: column;">
                                    <li v-for="(item, key) in recommentDocList" :key="key"
                                        style="word-wrap: break-word; white-space: normal">
                                        <h4 class="font-anuphan-regular-14 text-revamp-color-black"
                                            style="text-wrap: wrap;display: flex; align-items: center;">
                                            {{ item }}
                                        </h4>
                                    </li>
                                </ul>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <template v-if="getDocumentTypeIsRequire().length > 0">
                <b-row class="pt-3"><b-col
                        class="font-anuphan-bold-18 text-revamp-color-black">เอกสารประกอบการสมัคร</b-col></b-row>
                <b-row v-for="(item, key) in getDocumentTypeIsRequire()" :key="'require_' + key" class="pt-3">
                    <b-col>
                        <b-card class="card-border-radius common-shadow noborder"
                            style="width: 100%; background-color: #ffffff" @click="showExample(item)">
                            <b-row>
                                <b-col class="font-anuphan-regular-16-400 text-revamp-color-black">{{
            item.doc_short_name
        }}</b-col>
                                <b-col cols="1" class="px-0" style="padding-right: 32px !important"
                                    v-b-toggle="'my-collapse-list-account'">
                                    <b-icon icon="chevron-right" font-scale="1.2"
                                        style="color: var(--color-primary)" /></b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
            <template v-if="getDocumentTypeIsDeviate().length > 0">
                <b-row class="pt-3"><b-col class="font-anuphan-bold-18 text-revamp-color-black">เอกสารเพิ่มโอกาสพิจารณา
                        (ไม่บังคับ)</b-col></b-row>
                <b-row v-for="(item, key) in getDocumentTypeIsDeviate()" :key="'additional_' + key" class="pt-3">
                    <b-col>
                        <b-card class="card-border-radius common-shadow noborder"
                            style="width: 100%; background-color: #ffffff" @click="showExample(item)">
                            <b-row>
                                <b-col class="font-anuphan-regular-16-400 text-revamp-color-black">{{
            item.doc_short_name
                                    }}</b-col>
                                <b-col cols="1" class="px-0" style="padding-right: 32px !important"
                                    v-b-toggle="'my-collapse-list-account'">
                                    <b-icon icon="chevron-right" font-scale="1.2"
                                        style="color: var(--color-primary)" /></b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
        </div>
    </div>
</template>
<script>
import { exampleDoc } from "@/utils/popup/ExampleDoc.js";
import { GA_ACTIONS,PRODUCT_TYPE } from "@/utils/Constants.js";
export default {
    data() {
        return {
            documentType: [],
            recommentDocList: [],
        };
    },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
    },
    created() {
        this.$callback.gaTagging({
            action: GA_ACTIONS.VIEW,
            category: "DGLSelfApplyAppStatusDt_PndingUpld_Example",
            label: ""
        },
            [
                {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                }
            ]);
        this.$event.$on("onExitCallback", () => this.goToExitEntryPoint());
        const currentMenu = {
            pageCode: "CommonExampleDocTypeGroup",
            pageName: "ตัวอย่างเอกสาร",
            previousPage: "",
        };
        this.$event.$emit("update_current_menu", currentMenu);
        this.documentType = this.userData.documentType;
        this.recommentDocList = [
            "แสดงชื่อ-นามสกุล ต้องตรงกับผู้สมัครสินเชื่อ",
            "แนบภาพถ่ายหรือไฟล์ ที่มีข้อความชัดเจน เอกสารครบทุกหน้า ข้อความครบถ้วนไม่ขาดหาย",
        ];
        window.onMobileBackPressed = function () {
            this.$callback.openLfmStatusPage();
            return true;
        };
    },
    beforeDestroy() {
        this.$event.$off("onExitCallback");
    },
    methods: {
        getDocumentTypeIsRequire() {
            return this.documentType.filter((item) => !item.deviate_flag);
        },
        getDocumentTypeIsDeviate() {
            return this.documentType.filter((item) => item.deviate_flag);
        },
        showExample(documentTypeObj) {
            exampleDoc(documentTypeObj.example_doc, this.$swal, this.userData.isAndroid);
        },
        goToExitEntryPoint() {
            try {
                this.$callback.exitEntryPoint();
            } catch (err) {
                console.error(err);
            }
        },
    },
};
</script>
